import React, { useState } from 'react';
import { User, Mail, Phone, Lock, Building2 } from 'lucide-react';

const AdminForm = ({ companies, onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    companyId: companies[0]?._id || '',
    password: 'AdminPassword123!',
    permissions: {
      manageEmployees: true,
      viewAttendance: true,
      requestLimitIncrease: true,
      exportReports: true
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePermissionToggle = (key) => {
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [key]: !prev.permissions[key]
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-slate-600 mb-1.5">Admin Full Name *</label>
        <div className="relative">
          <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            placeholder="e.g. David Miller"
            className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">Email Address *</label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              placeholder="admin@company.com"
              className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">Phone Number</label>
          <div className="relative">
            <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+1 555-0144"
              className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">Assigned Company *</label>
          <div className="relative">
            <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <select
              name="companyId"
              required
              value={formData.companyId}
              onChange={handleChange}
              className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            >
              <option value="">-- Select Company --</option>
              {companies.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.name} ({c.employeeIdPrefix})
                </option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">Password *</label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              type="text"
              name="password"
              required
              value={formData.password}
              onChange={handleChange}
              className="w-full pl-9 pr-3.5 py-2 rounded-xl bg-white border border-slate-100 text-xs sm:text-sm text-slate-700 focus:outline-none focus:border-green-600 transition"
            />
          </div>
        </div>
      </div>

      {/* Permissions toggles */}
      <div>
        <label className="block text-xs font-medium text-slate-600 mb-2">Permissions</label>
        <div className="grid grid-cols-2 gap-2 text-xs">
          {Object.entries(formData.permissions).map(([key, enabled]) => (
            <label
              key={key}
              className="flex items-center space-x-2 p-2.5 rounded-xl bg-white border border-slate-100 cursor-pointer hover:bg-slate-50/40 transition"
            >
              <input
                type="checkbox"
                checked={enabled}
                onChange={() => handlePermissionToggle(key)}
                className="rounded border-slate-700 bg-white text-green-700 focus:ring-green-600"
              />
              <span className="capitalize text-slate-600">{key.replace(/([A-Z])/g, ' $1')}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-end space-x-3 pt-4 border-t border-slate-100">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 rounded-xl text-xs font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-900 transition"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-2 rounded-xl text-xs font-semibold text-white bg-green-700 hover:bg-green-600 shadow-lg shadow-green-700/30 disabled:opacity-50 transition"
        >
          {loading ? 'Creating...' : 'Create Admin Account'}
        </button>
      </div>
    </form>
  );
};

export default AdminForm;
